/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackagingReturn } from '../../models/packaging-return';

export interface PackagingReturnsControllerFindById$Params {
  id: string;
}

export function packagingReturnsControllerFindById(http: HttpClient, rootUrl: string, params: PackagingReturnsControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingReturn>> {
  const rb = new RequestBuilder(rootUrl, packagingReturnsControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingReturn>;
    })
  );
}

packagingReturnsControllerFindById.PATH = '/packaging-returns/{id}';
